import { render } from "./SeoEditItemNew.vue?vue&type=template&id=5f3bb9ac&scoped=true"
import script from "./SeoEditItemNew.vue?vue&type=script&lang=js"
export * from "./SeoEditItemNew.vue?vue&type=script&lang=js"

import "./SeoEditItemNew.vue?vue&type=style&index=0&id=5f3bb9ac&lang=css"
import "./SeoEditItemNew.vue?vue&type=style&index=1&id=5f3bb9ac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3bb9ac"]])

export default __exports__